import * as ServiceWorkerApi from "@api/serviceWorkerAPI";

var senderInstance = null;
var pluginSendQueue = [];

export const defaultJSONFormat = ({
  message,
  methodName,
  logLevel,
  loggerName,
  user_id,
  scopes,
  application,
}) => {
  return JSON.stringify({
    message: message,
    level: (methodName || "").toUpperCase(),
    logLevel,
    logger: loggerName || "",
    timestamp: new Date().toISOString(),
    user_id: user_id,
    scopes: scopes,
    application,
  });
};

const setLogInstance = (instance) => {
  if (!senderInstance) {
    senderInstance = instance;
  }
  return senderInstance;
};

const sender = async (options) => {
  if (!senderInstance || !senderInstance.methodFactory) {
    throw new Error(
      "loglevel instance has to be specified in order to be extended"
    );
  }

  let pluginLogger = senderInstance,
    pluginCallOriginal = (options && options.callOriginal) || false,
    pluginLevel = (options && options.level) || "error",
    pluginFormat = (options && options.format) || defaultJSONFormat,
    pluginOriginalFactory = pluginLogger.methodFactory,
    pluginIsSending = false,
    pluginApplication = (options && options.application) || null,
    pluginSendInterval = (options && options.senderInterval) || null,
    pluginToken = (await (options && options.token)) || null,
    pluginUserId = (await (options && options.user_id)) || null,
    pluginScopes = (await (options && options.scopes)) || null;

  pluginLogger.methodFactory = (methodName, logLevel, loggerName) => {
    let rawMethod = pluginOriginalFactory(methodName, logLevel, loggerName);

    return (message) => {
      const formattedMessage = pluginFormat({
        message: message,
        methodName: methodName,
        logLevel: logLevel,
        loggerName: loggerName,
        user_id: pluginUserId,
        scopes: pluginScopes,
        application: pluginApplication,
      });

      if (pluginCallOriginal) {
        rawMethod(message);
      }

      pluginSendQueue.push(formattedMessage);
    };
  };
  pluginLogger.setLevel(pluginLevel);

  const sendStack = () => {
    if (!pluginSendQueue.length || pluginIsSending) {
      return null;
    }

    // Set flag to indicate that we are sending
    pluginIsSending = true;

    // Clear the queue messages
    let validQueue = pluginSendQueue.map((message, i) => {
      let validMessage = JSON.parse(message);
      validMessage.user_id = pluginUserId;
      validMessage.scopes = pluginScopes;
      return JSON.stringify(validMessage);
    });

    //Check the queue length to send to the server
    ServiceWorkerApi.sendLogs(pluginToken, validQueue)
      .then((response) => {
        pluginSendQueue = [];
        pluginIsSending = false;
      })
      .finally(() => {
        pluginIsSending = false;
      });
  };

  if (pluginToken && pluginUserId && pluginScopes) {
    // setInterval(sendStack, pluginSendInterval);
    sendStack();
  }
};

export { sender, setLogInstance };
